/**
 * Separa una lista de teléfonos pegada a mano o leída de un CSV/TXT.
 *
 * Acepta como separador salto de línea, coma, punto y coma, tab o espacio:
 *   "+5493511234567 +593998660210"         -> 2 números
 *   "+5493511234567\n+593998660210"        -> 2 números
 *   "+54 9 351 123 4567"                   -> 1 número (los espacios internos se respetan)
 *   "3511234567 3517654321"                -> 2 números
 *
 * Descarta encabezados o celdas sin dígitos (ej. "telefono") y repetidos.
 */
const MIN_DIGITS = 8;

const digitsCount = (text) => text.replace(/\D/g, "").length;

function splitChunk(chunk) {
  const clean = chunk.replace(/["']/g, "").trim();
  if (!clean) return [];

  // Varios números con "+" en la misma celda/línea
  if ((clean.match(/\+/g) || []).length > 1) {
    return clean.split(/\s+(?=\+)/).map((s) => s.trim());
  }

  // Varios números sin "+" separados por espacio, cada uno "completo"
  const tokens = clean.split(/\s+/);
  if (tokens.length > 1 && tokens.every((t) => digitsCount(t) >= MIN_DIGITS)) {
    return tokens;
  }

  // Un solo número, posiblemente con espacios internos
  return [clean];
}

export function parsePhoneList(text) {
  const result = String(text || "")
    .split(/[\r\n,;\t]+/)
    .flatMap(splitChunk)
    .filter((n) => /\d/.test(n));
  return [...new Set(result)];
}
